import { componentAttributeTypes } from "vagaro-website-rendering/src/components/Definitions/AttributeTypes";
import LayoutNode, { getNodeComponentAttributeValue } from "vagaro-website-rendering/src/components/Definitions/LayoutNode";

//UTILITY for rendering business controls as a single div with a data-link-key and layout attribute for the BindDataToComponents function to bind to
export default function BusinessPlaceHolder({dataKey,layout,node,classNames,children,inFilter}:{inFilter?:string,node:LayoutNode,dataKey:string,layout:string,classNames:string,children?:any}) {

    let dataAtts:any = {"data-link-key":dataKey,"layout":layout};

    let bid =   getNodeComponentAttributeValue(node, componentAttributeTypes.multiLocation, "");
    let allowMulti = getNodeComponentAttributeValue(node, componentAttributeTypes.alloWMultiLocalationBooking, "");

    // `inFilter` will override the `filter` being returned by getNodeComponentAttributeValue (is this something we want?) 
    let filters = inFilter ?? getNodeComponentAttributeValue(node, componentAttributeTypes.filters, inFilter??"");
    let mapView = getNodeComponentAttributeValue(node, componentAttributeTypes.mapView, "1");
    let isShowLogo = getNodeComponentAttributeValue(node, componentAttributeTypes.isShowLogo, "true");

    let formfc = getNodeComponentAttributeValue(node, componentAttributeTypes.formfc, "");
    let formbg = getNodeComponentAttributeValue(node, componentAttributeTypes.formbg, "");
    let displayform = getNodeComponentAttributeValue(node, componentAttributeTypes.displayform, "true");

    if(bid && bid.length>2){
        dataAtts.encbid = bid;
    }

    dataAtts.multilocal = (allowMulti==="true")?"true":"false";
    
    if(filters && filters.length>2){
        dataAtts.filters = encodeURIComponent (filters);   
    }

    if(dataKey == "location" && mapView && mapView.length > 0){
        dataAtts.filters = encodeURIComponent (mapView);   
    }

    if(dataKey == "location" && isShowLogo && isShowLogo.length > 0){
        dataAtts.isShowLogo = encodeURIComponent (isShowLogo);   
    }
    
    if(dataKey == "form" && formfc && formfc.length > 0){
        dataAtts.formfc =  formfc;   
    }
    if(dataKey == "form" && formbg && formbg.length > 0){
        dataAtts.formbg =  formbg;   
    }
    if(dataKey == "form" && displayform && displayform.length > 0){
        dataAtts.displayform =  displayform;   
    }

    dataAtts.multilocal = (allowMulti==="true")?"true":"false";
    

    let tokens = node? node.tokenClasses:"";

    //if the provided classNames already include a vwb- class, then we don't want to add the token classes
    if(classNames.includes("vwb-")){
        tokens = "";
    }
    
    return <div  id={"v"+node.id} {...dataAtts} className={tokens+" "+classNames+" vb-control" }>{children}</div>

}